import Cookies from "js-cookie";
import { v4 as uuidv4 } from "uuid";

export function createCookie(name, domain) {
    const id = uuidv4();
    Cookies.set(name, id, { domain: domain, expires: 365 });
    return id;
}

export function getCookie(name) {
    return Cookies.get(name);
}
